// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import VitaloraHome from "./view";

import PendingComponent from "../../components/PendingComponent";
import { isDemoEnterprise } from "../../utils/auth";
import { askPunttRoute } from "../ask-puntt/route";
import { authLayoutRoute } from "../auth-layout/route";

/**
 * Demo-only homepage. Lives at `/home` so a deep link survives reseeds.
 *
 * Non-demo users that hit this route get redirected to the existing
 * Ask Puntt landing — there is nothing to render for them and we never
 * want a real customer's app to surface "Vitalora Consumer Brands"
 * chrome by accident.
 */
export const vitaloraHomeRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "home",
  beforeLoad() {
    if (!isDemoEnterprise()) {
      throw redirect({ to: askPunttRoute.to });
    }
  },
  component: VitaloraHome,
  pendingComponent: PendingComponent,
  pendingMs: 0,
  pendingMinMs: 200,
});
